<template>
  <div id="income" class="invite">
    <div class="top">
      <h2>收入</h2>
      <router-link to="/cash" tag="span" class="link">提现钱包</router-link>
    </div>
    <Total :rule="rule" />
    <router-link to="/promo/1" tag="p" class="link" v-if="$store.state.user.identity === 1">
      成为合作伙伴，解锁百万收入空间
      <i class="anyteachicon anyteach-next1" />
    </router-link>
    <div v-if="rule.basic_income > 0">
      <h3>基础收入完成度</h3>
      <div class="bar-wrapper card">
        <div class="head">
          <div class="switcher" v-if="rule.total_income !== rule.now_income">
            <span :class="{ active: mode === 'total' }" @click="mode = 'total'">总收入</span>
            <span :class="{ active: mode === 'now' }" @click="mode = 'now'">已提现</span>
          </div>
          <div class="basic-income">¥{{ rule.basic_income }}</div>
        </div>
        <div ref="bar" class="bar">
          <div ref="progress" class="current">
            <span
              class="percentage animated fadeIn"
              v-if="width > 35"
            >{{ Number(percentage * 100).toFixed(1) }}%</span>
            <span
              v-else
              class="percentage percentage-outside animated fadeIn"
            >{{ Number(percentage * 100).toFixed(1) }}%</span>
          </div>
        </div>
        <div ref="income" v-if="rule.total_income < rule.basic_income" class="total-income">
          <span v-if="mode === 'total'">¥{{ rule.total_income }}</span>
          <span v-if="mode === 'now'">¥{{ rule.now_income }}</span>
        </div>
        <div v-else ref="income" class="total-income income-completed">
          <i class="anyteachicon anyteach-check-circle" />
          <span>恭喜您完成基础收入</span>
          <router-link tag="p" to="/cash" v-if="rule.now_income < rule.total_income">
            <span>，</span>
            <span class="red">还有 ¥{{ rule.total_income - rule.now_income }} 未提现</span>
          </router-link>
        </div>
      </div>
    </div>
    <Ratio :rule="rule" />
  </div>
</template>

<script>
import Total from "./Total"
import Ratio from "./Ratio"

export default {
  props: ["rule"],
  components: { Total, Ratio },
  data() {
    return {
      percentage: 0,
      width: 0,
      mode: "total",
    }
  },
  watch: {
    mode: function (val) {
      this.setProgress()
    },
  },
  methods: {
    setProgress() {
      if (!this.rule.basic_income) return
      const income = this.mode === "total" ? this.rule.total_income : this.rule.now_income
      const totalWidth = this.$refs.bar.clientWidth
      this.percentage = Number(
        Number(income / this.rule.basic_income)
          .toString()
          .substring(0, 5),
      )
      if (this.percentage > 1) this.percentage = 1
      this.width = Math.floor(totalWidth * this.percentage)
      this.$refs.progress.style.width = this.width + "px"
      if (this.rule.total_income < this.rule.basic_income) {
        let marginLeft = this.width - this.$refs.income.clientWidth / 2
        if (marginLeft < -5) {
          marginLeft = -5
        } else if (marginLeft > totalWidth - this.$refs.income.clientWidth) {
          marginLeft -= 10
        }
        this.$refs.income.style.marginLeft = marginLeft + "px"
      }
    },
  },
  mounted() {
    this.setProgress()
  },
}
</script>

<style lang="scss" scoped>
@import "./style.scss";
#income {
  margin-bottom: 25px;

  .top {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 0 0 5px 0;
    .link {
      margin: 0;
    }
  }
  .link {
    @include avenir-demi();
    font-size: 0.8rem;
    color: $red;
    padding: 0;
    margin-top: -5px;
    margin-bottom: -10px;
    &:active {
      opacity: 0.6;
    }
    i {
      font-size: inherit;
    }
  }
}

.bar-wrapper {
  padding: 5px 10px;
  .head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 0.8rem;
    .switcher {
      span {
        opacity: 0.6;
        transition: all 0.3s;
      }
      .active {
        opacity: 1;
        color: $red;
        @include avenir-demi();
        font-weight: 500;
      }
    }
  }
  .total-income,
  .basic-income {
    @include avenir-demi();
    font-weight: 500;
    font-size: 0.8rem;
  }
  .total-income {
    display: inline-block;
    transition: margin 0.5s ease;
  }
  .basic-income {
    text-align: right;
    flex-grow: 1;
  }
  .income-completed {
    display: block;
    text-align: center;
    p {
      display: inline-block;
      font-size: 0;
      line-height: 1;
      padding: 0;
      font-weight: 500;
    }
    span,
    i {
      font-size: 0.8rem;
    }
    i {
      margin-right: 3px;
    }
  }
  .bar {
    $radius: 4px;
    $height: 25px;
    width: 100%;
    height: $height;
    border-radius: 4px;
    border: 1px solid $red;
    overflow: hidden;
    box-sizing: content-box;
    .current {
      width: 0;
      transition: width 0.5s ease;
      height: $height;
      background: $red;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
    }
    .percentage {
      font-size: 0.75rem;
      font-weight: 400;
      color: white;
    }
    .percentage-outside {
      color: $black;
      position: absolute;
      right: -35px;
    }
  }
}
</style>
